export const common = {
  nav: {
    overview: 'Overzicht',
    services: 'Diensten',
    industries: 'Sectoren',
    about: 'Over Ons',
    contact: 'Contact',
    getStarted: 'Aan de Slag'
  },
  hero: {
    badge: 'Wereldwijde IT-oplossingenprovider',
    title: 'Infrastructuur die uw Digitale Toekomst Aandrijft',
    subtitle: 'Uw digitaal Zwitsers zakmes voor uitgebreide IT-excellentie. Van complexe infrastructuurprojecten tot geavanceerde audiovisuele en bewakingsoplossingen - wij leveren professionele resultaten in elk technologiedomein.',
    exploreSolutions: 'Ontdek Oplossingen',
    learnMore: 'Meer Informatie'
  },
  services: {
    sectionTitle: 'ONZE EXPERTISE',
    title: 'Uitgebreide IT-oplossingen op Maat van uw Bedrijf',
    subtitle: 'We leveren op maat gemaakte IT-diensten die uw unieke uitdagingen aanpakken en uw bedrijf vooruit helpen.',
    learnMore: 'Meer informatie',
    itInfrastructure: {
      title: 'IT-infrastructuur',
      description: 'Schaalbare netwerkoplossingen ontworpen om uw bedrijfsgroei te ondersteunen. Van serverbeheer tot cloudintegratie, we bouwen robuuste infrastructuur die betrouwbaarheid en prestaties garandeert.'
    },
    digitalisation: {
      title: 'Digitalisering',
      description: 'Transformeer uw bedrijfsprocessen met geavanceerde digitale oplossingen. We helpen organisaties hun activiteiten te moderniseren, efficiëntie te verbeteren en concurrerend te blijven in het digitale tijdperk.'
    },
    backup: {
      title: 'Back-upoplossingen',
      description: 'Uitgebreide gegevensbescherming en noodherstelsystemen. Bescherm uw kritieke bedrijfsgegevens met geautomatiseerde back-ups, veilige opslag en snelle herstelmogelijkheden.'
    },
    surveillance: {
      title: 'Bewakingssystemen',
      description: 'Geavanceerde beveiligingsmonitoringoplossingen op maat van uw behoeften. Bescherm uw activa met state-of-the-art bewakingstechnologie en 24/7 monitoringmogelijkheden.'
    },
    cybersecurity: {
      title: 'Cyberbeveiliging',
      description: 'Bescherm uw bedrijf tegen evoluerende cyberdreigingen met uitgebreide beveiligingsoplossingen. We implementeren geavanceerde dreigingsdetectie, preventiesystemen en beveiligingsprotocollen om uw digitale activa te beschermen.'
    },
    managedServices: {
      title: 'Managed Services',
      description: 'Focus op uw kernactiviteiten terwijl wij uw IT-operaties beheren. Onze managed services bieden proactieve monitoring, onderhoud en ondersteuning om uw systemen 24/7 soepel te laten draaien.'
    },
    projectManagement: {
      title: 'Projectbeheer',
      description: 'Deskundig projectbeheer dat succesvolle IT-implementaties garandeert. We leveren projecten op tijd en binnen budget, waarbij we alle aspecten coördineren van planning tot implementatie met bewezen methodologieën.'
    },
    cisoService: {
      title: 'CISO-as-a-Service',
      description: 'Toegang tot beveiligingsexpertise op directieniveau zonder voltijdse kosten. Onze virtuele CISO-service biedt strategisch beveiligingsleiderschap, nalevingsadvies en risicobeheer voor uw organisatie.'
    }
  },
  industries: {
    title: 'Sectoren die we Bedienen',
    subtitle: 'Vertrouwd door organisaties in alle sectoren wereldwijd, met uitmuntendheid in elk project.',
    industry: {
      name: 'Industrie',
      description: 'Productie- en fabricagefaciliteiten'
    },
    retail: {
      name: 'Retail',
      description: 'Winkels en e-commerceplatforms'
    },
    healthcare: {
      name: 'Gezondheidszorg',
      description: 'Ziekenhuizen en medische centra'
    },
    government: {
      name: 'Overheid',
      description: 'Publieke sector organisaties'
    }
  },
  about: {
    sectionTitle: 'OVER ONS',
    title: 'Uw Vertrouwde IT-partner vanaf Dag Één',
    description: 'Gevestigd in West-Vlaanderen, België, zijn wij een toonaangevende IT-dienstverlener met een wereldwijd bereik. Ons team van gecertificeerde professionals levert innovatieve oplossingen in alle sectoren - van productie en retail tot gezondheidszorg en overheidssectoren.',
    mission: 'Onze missie is om bedrijven te versterken met betrouwbare, veilige en schaalbare IT-infrastructuur die digitale transformatie en operationele uitmuntendheid stimuleert.',
    gdprCompliant: 'AVG-conform',
    support247: '24/7 Ondersteuning'
  },
  cta: {
    title: 'Klaar om uw IT-infrastructuur te transformeren? Laten we samen iets uitzonderlijks bouwen.',
    button: 'Plan Consultatie'
  },
  contact: {
    sectionTitle: 'NEEM CONTACT OP',
    title: 'Laten we uw IT-behoeften Bespreken',
    subtitle: 'Vul het onderstaande formulier in en we nemen binnen 24 uur contact met u op',
    subtitleShort: 'Vul het onderstaande formulier in en we nemen binnen 24 uur contact met u op',
    form: {
      name: 'Volledige Naam',
      email: 'E-mailadres',
      company: 'Bedrijfsnaam',
      phone: 'Telefoonnummer',
      message: 'Bericht',
      verification: 'Verificatie: Hoeveel is',
      verificationPlaceholder: 'Voer het antwoord in',
      required: '*',
      namePlaceholder: 'Jan Janssen',
      emailPlaceholder: 'jan@bedrijf.be',
      companyPlaceholder: 'Uw Bedrijf',
      phonePlaceholder: '+32 123 45 67 89',
      messagePlaceholder: 'Vertel ons over uw IT-behoeften...',
      charactersCount: 'tekens',
      submit: 'Verstuur Bericht',
      sending: 'Verzenden...',
      successMessage: 'Bedankt! Uw bericht is succesvol verzonden. We nemen binnenkort contact met u op.',
      errorMessage: 'Beantwoord de verificatievraag correct en probeer het opnieuw.'
    }
  },
  footer: {
    description: 'Toonaangevende IT-dienstverlener die innovatieve oplossingen levert voor infrastructuur, digitalisering, back-up en bewaking wereldwijd.',
    solutions: 'Oplossingen',
    copyright: '© 2025 IT Services. Alle rechten voorbehouden.',
    poweredBy: 'Mogelijk gemaakt door Readdy',
    privacy: 'Privacybeleid',
    terms: 'Servicevoorwaarden'
  },
  cookies: {
    title: 'Wij respecteren uw privacy',
    description: 'We gebruiken cookies om uw browse-ervaring te verbeteren, gepersonaliseerde inhoud te leveren en ons verkeer te analyseren. Door op "Alles accepteren" te klikken, stemt u in met ons gebruik van cookies.',
    customize: 'Aanpassen',
    acceptAll: 'Alles accepteren',
    rejectAll: 'Alles weigeren',
    savePreferences: 'Voorkeuren opslaan',
    settingsTitle: 'Cookie voorkeuren',
    necessary: 'Noodzakelijke cookies',
    alwaysActive: 'Altijd actief',
    necessaryDesc: 'Deze cookies zijn essentieel voor het correct functioneren van de website. Ze maken basisfuncties mogelijk zoals paginanavigatie en toegang tot beveiligde gebieden.',
    analytics: 'Analytische cookies',
    analyticsDesc: 'Deze cookies helpen ons te begrijpen hoe bezoekers omgaan met onze website door anoniem informatie te verzamelen en te rapporteren.',
    marketing: 'Marketing cookies',
    marketingDesc: 'Deze cookies worden gebruikt om bezoekers op websites te volgen om relevante advertenties en marketingcampagnes weer te geven.'
  }
};
